<template>
    <div>
        <base-title
            :title="StringLanguage.marketingAutomation"
            subtitle="Fidelização e marketing"
            :link="'fidelizacao'"
        >
            <base-button :text="StringLanguage.generalResults" design="two" />
            <base-button :text="StringLanguage.manageTriggers" design="two" class="ml_10" />
        </base-title>

        <div class="row">
            <div class="col-lg-6" v-for="(campaign, index) in campaigns" :key="index"> <!-- v-for -->
                <campaign :status="campaign.status" :name="campaign.name" :icon="`far ${campaigntypes[campaign.alias].icon}`" @action="buttonActions" :id="campaign.id">
                    {{ campaigntypes[campaign.alias].description }}
                </campaign>
            </div>

            <!-- Nova campanha -->
            <div class="col-lg-6" v-if="!isLoadingData">
                <base-add :text="StringLanguage.customCampaign.toUpperCase()" :height="'210px'" @click.native="$router.push({ name: 'criar' })"/>
            </div>
        </div>
    </div>
</template>
<script>
import BaseTitle from '@/components/Title'
import BaseButton from '@/components/Button'
import BaseBox from '@/components/Box'
import BaseAdd from '@/components/Add'

import Campaign from '@/containers/Marketing/Campaign'
import { mapState } from 'vuex'

import WorkingTime from "@/plugins/core/schema/configurations/WorkingTime/WorkingTime";
import MarketingAPI from '@/api/marketing'
import StoreAPI from '@/api/store'

export default {
    components: {
        BaseTitle,
        BaseButton,
        BaseBox,
        BaseAdd,
        Campaign
    },
    data () {
        return {
            campaigns: [],
            isLoadingData: false,
        }
    },
    created () {
        const self = this
        this.isLoadingData = true
        MarketingAPI.campaigns().then(result => {
            if(result.getErrors([]).length > 0) {
                alert(StringLanguage.loadError);
                return;
            }
            self.campaigns = result.getData({ campaings: [] }).campaigns
        }).catch((err) => {
            alert(StringLanguage.loadError);
        }).finally(() => {
            this.isLoadingData = false
        })
    },
    methods: {
        buttonActions(param) {
            switch(param.action) {
                case 1:
                    this.pauseCampaign(param.id)
                    break

                case 2:
                    this.activeCampaign(param.id)
                    break

                case 3:
                    this.editCampaign(param.id)
                    break
            }
        },
        pauseCampaign(id) {
            const self = this
            confirm(StringLanguage.confirmPauseCampaign, function() {
                MarketingAPI.changeStatus(id, 'PAUSED').then(result => {
                    if (result.getCode(false) === 200 && result.getData({ changeCampaignStatus: null }).changeCampaignStatus) {
                        for (let i in self.campaigns) {
                            if (self.campaigns[i].id === id) {
                                self.campaigns[i].status = 'PAUSED'
                            }
                        }
                    }
                })
            })
        },
        activeCampaign(id) {
            const self = this
            confirm(StringLanguage.confirmActiveCampaign, function() {
                MarketingAPI.changeStatus(id, 'SCHEDULED').then(result => {
                    if (result.getCode(false) === 200 && result.getData({ changeCampaignStatus: null }).changeCampaignStatus) {
                        for (let i in self.campaigns) {
                            if (self.campaigns[i].id === id) {
                                self.campaigns[i].status = 'WAITING'
                            }
                        }
                    }
                })
            })
        },
        editCampaign(id) {
            this.$router.push({name: 'editar', params: {id: id}})
        }
    },

    computed: {
        ...mapState ({
            campaigntypes: state => state.marketing.campaigntypes
        })
    }

}
</script>